import React from 'react';
import {useField} from 'react-final-form';
import MultiButton from 'common/componentsV2/multiButton/MultiButton';
import TooltipArea from 'common/componentsV2/TooltipArea';

const SEVERITY_TYPES = [
  {
    label: 'Info',
    value: 'info',
    color: '#17406f',
  },
  {
    label: 'Low',
    value: 'low',
    color: '#30de50',
  },
  {
    label: 'Medium',
    value: 'medium',
    color: '#ffac3d',
  },
  {
    label: 'High',
    value: 'high',
    color: '#f9691f',
  },
  {
    label: 'Critical',
    value: 'critical',
    color: '#d10f37',
  },
];

const AlertName = () => {
  const {
    input: {value, onChange},
  } = useField('severity');
  return (
    <TooltipArea
      automationId="severityContainer"
      text="Choose the severity of this alert, this will show up on every trigger"
    >
      {(info) => (
        <React.Fragment>
          <div className="text16reg lineHeight_16 mb_1">
            Severity
            {info}
          </div>
          <MultiButton automationId="severityTypes" value={value} options={SEVERITY_TYPES} onChange={onChange} />
        </React.Fragment>
      )}
    </TooltipArea>
  );
};

export default AlertName;
